var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-img"},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":_vm.alt,"width":_vm.width,"height":_vm.height,"onerror":_vm.handleDefaultImg}})])}
var staticRenderFns = []

export { render, staticRenderFns }